// A post's category is optional text the admin types ("Compliance",
// "Product"); "" means none and nothing is shown.
// The categories already used, A to Z, offered when writing a new post.
export const usedCategories = (updates) =>
  [
    ...new Set(
      (updates || []).map((u) => (u.category || "").trim()).filter(Boolean)
    ),
  ].sort((a, b) => a.localeCompare(b));

export const UPDATE_STATUSES = {
  published: "Published",
  draft: "Draft",
};

// Published posts, newest first. Drafts never reach the public page.
export const publishedUpdates = (updates) =>
  (updates || [])
    .filter((u) => u.status === "published")
    .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));

export const formatDate = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "";

export const FRAMEWORK_STATUSES = {
  compliant: "Compliant",
  in_progress: "In progress",
};

// Today's date as YYYY-MM-DD in the viewer's time zone.
const todayIso = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

// A valid-until date (YYYY-MM-DD) that is already behind us.
export const isPastDate = (date) => !!date && date < todayIso();

// The server flags expired frameworks; isPastDate covers an edit that has not
// been saved yet.
export const frameworkExpired = (framework) =>
  !!framework.expired || isPastDate(framework.validUntil);
